import { useIntl } from "react-intl";
import { Dispatch, SetStateAction } from "react";
import { useScrollIntoView } from "@mantine/hooks";
import classNames from "classnames";
import Link from "next/link";
import { LoginIcon } from "@/public/icons/LoginIcon";
import { FAQIcon } from "@/public/icons/FAQIcon";
// import { LocationsIcon } from "@/public/icons/LocationsIcon";
import { BillingIcon } from "@/public/icons/BillingIcon";
// import { DriversIcon } from "@/public/icons/DriversIcon";
import { AccountTabType } from "@/components/pages/account/Account";
import { Section } from "@/components/common/section/Section";
import { routes } from "@/routes/routes";
import styles from "./AccountMenu.module.scss";

type AccountMenuProps = {
  selectedTab: AccountTabType;
  setSelectedTab: Dispatch<SetStateAction<AccountTabType>>;
  lastname: string;
  firstname: string;
  isB2B?: boolean;
};

export const AccountMenu = ({
  selectedTab,
  setSelectedTab,
  lastname,
  firstname,
  isB2B = false,
}: AccountMenuProps) => {
  const intl = useIntl();

  const { scrollIntoView, targetRef, scrollableRef } =
    useScrollIntoView<HTMLDivElement>({
      axis: "x",
    });

  const changeTab = (tab: AccountTabType) => {
    setSelectedTab(tab);
    setTimeout(() => {
      scrollIntoView({ alignment: "center" });
    }, 100);
  };

  return (
    <div className={styles.menu}>
      <Section containerStyle={styles.menuContent}>
        <div className={styles.menuTitle}>
          {intl.formatMessage(
            { id: "accountGreet" },
            {
              lastname: lastname,
              firstname: firstname,
            }
          )}
        </div>
        <div className={styles.menuTabs} ref={scrollableRef}>
          <div className={styles.scrollableTabs}>
            {/* {!isB2B && (
              <div
                className={classNames(styles.menuTab, {
                  [styles.selectedMenuTab]:
                    selectedTab === AccountTabType.LOCATIONS,
                })}
                onClick={() => changeTab(AccountTabType.LOCATIONS)}
                ref={
                  selectedTab === AccountTabType.LOCATIONS
                    ? targetRef
                    : undefined
                }
              >
                <div className={styles.menuTabIcon}>
                  <LocationsIcon
                    color={
                      selectedTab === AccountTabType.LOCATIONS
                        ? "white"
                        : "#3f4756"
                    }
                  />
                </div>
                <div className={styles.menuTabLabel}>
                  {intl.formatMessage({ id: "locations" })}
                </div>
              </div>
            )} */}
            {isB2B && (
              <div
                className={classNames(styles.menuTab, {
                  [styles.selectedMenuTab]:
                    selectedTab === AccountTabType.BILLING,
                })}
                onClick={() => changeTab(AccountTabType.BILLING)}
                ref={
                  selectedTab === AccountTabType.BILLING ? targetRef : undefined
                }
              >
                <div className={styles.menuTabIcon}>
                  <BillingIcon
                    color={
                      selectedTab === AccountTabType.BILLING
                        ? "white"
                        : "#3f4756"
                    }
                  />
                </div>
                <div className={styles.menuTabLabel}>
                  {intl.formatMessage({ id: "billing" })}
                </div>
              </div>
            )}
            {!isB2B && (
              <div
                className={classNames(styles.menuTab, {
                  [styles.selectedMenuTab]:
                    selectedTab === AccountTabType.MY_ACCOUNT,
                })}
                onClick={() => changeTab(AccountTabType.MY_ACCOUNT)}
                ref={
                  selectedTab === AccountTabType.MY_ACCOUNT
                    ? targetRef
                    : undefined
                }
              >
                <div className={styles.menuTabIcon}>
                  <LoginIcon
                    color={
                      selectedTab === AccountTabType.MY_ACCOUNT
                        ? "white"
                        : "#3f4756"
                    }
                  />
                </div>
                <div className={styles.menuTabLabel}>
                  {intl.formatMessage({ id: "account" })}
                </div>
              </div>
            )}
            {!isB2B && (
              <div className={styles.menuTab}>
                <Link href={routes.faq} passHref={true}>
                  <div className={styles.helpTab}>
                    <div className={styles.menuTabIcon}>
                      <FAQIcon color="#3f4756" />
                    </div>
                    <div className={styles.menuTabLabel}>
                      {intl.formatMessage({ id: "help" })}
                    </div>
                  </div>
                </Link>
              </div>
            )}
            {/* <div
              className={classNames(styles.menuTab, {
                [styles.selectedMenuTab]:
                  selectedTab === AccountTabType.DRIVERS,
              })}
              onClick={() => changeTab(AccountTabType.DRIVERS)}
              ref={
                selectedTab === AccountTabType.DRIVERS ? targetRef : undefined
              }
            >
              <div className={styles.menuTabIcon}>
                <DriversIcon
                  color={
                    selectedTab === AccountTabType.DRIVERS ? "white" : "#3f4756"
                  }
                />
              </div>
              <div className={styles.menuTabLabel}>
                {intl.formatMessage({ id: "drivers" })}
              </div>
            </div> */}
          </div>
        </div>
      </Section>
    </div>
  );
};
